import $  from 'jquery';

export const setTotal = () => {
    let sum = 0;
    $('.js-sum').each(function () {
        sum += +($(this).text());
        $('.js-product-buy-total span').html(sum);
    })
}
